import { lazy } from 'react'
import { getLoadedReportPage, loadReportPage } from './reportPageLoader'

const LazyReportPage = lazy(loadReportPage)

export default function AssessmentReportRoute() {
  // A freshly initialized React.lazy still suspends once, even for a resolved import.
  // Use the prepared component directly; retain lazy loading for bookmarked report URLs.
  const ReportPage = getLoadedReportPage() ?? LazyReportPage
  return <ReportPage />
}
